/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Restore_No_Transaction_TitleInputs */

const en_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscription record found`)
};

const ar_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على سجل اشتراك`)
};

const de_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Abonnement-Datensatz gefunden`)
};

const es_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se han encontrado registros de suscripción`)
};

const fr_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun abonnement trouvé`)
};

const it_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato di abbonamento trovato`)
};

const ja_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション記録が見つかりません`)
};

const ko_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 기록을 찾을 수 없어요`)
};

const pt_br_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro de assinatura encontrado`)
};

const ru_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи о подписке не найдены`)
};

const th_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีบันทึกการสมัครสมาชิก`)
};

const tr_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik kaydı bulunamadı`)
};

const zh_cn_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查无 Plus 会员购买记录`)
};

const zh_tw_dialog_restore_no_transaction_title = /** @type {(inputs: Dialog_Restore_No_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查無訂閱紀錄`)
};

/**
* | output |
* | --- |
* | "No subscription record found" |
*
* @param {Dialog_Restore_No_Transaction_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_no_transaction_title = /** @type {((inputs?: Dialog_Restore_No_Transaction_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_No_Transaction_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_no_transaction_title(inputs)
	if (locale === "ar") return ar_dialog_restore_no_transaction_title(inputs)
	if (locale === "de") return de_dialog_restore_no_transaction_title(inputs)
	if (locale === "es") return es_dialog_restore_no_transaction_title(inputs)
	if (locale === "fr") return fr_dialog_restore_no_transaction_title(inputs)
	if (locale === "it") return it_dialog_restore_no_transaction_title(inputs)
	if (locale === "ja") return ja_dialog_restore_no_transaction_title(inputs)
	if (locale === "ko") return ko_dialog_restore_no_transaction_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_no_transaction_title(inputs)
	if (locale === "ru") return ru_dialog_restore_no_transaction_title(inputs)
	if (locale === "th") return th_dialog_restore_no_transaction_title(inputs)
	if (locale === "tr") return tr_dialog_restore_no_transaction_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_no_transaction_title(inputs)
	return zh_tw_dialog_restore_no_transaction_title(inputs)
});